module.exports = __webpack_public_path__ + "img/paul_54.61773ff7.jpg";